import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule, MatRadioModule, MatRippleModule, MatTooltipModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { PreviousWarrantyDialogComponent } from './previous-warranty-dialog.component';

@NgModule({
  entryComponents: [
    PreviousWarrantyDialogComponent
  ],
  declarations: [
    PreviousWarrantyDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatTooltipModule,
    MatRippleModule,
    MatDialogModule,
    FuseSharedModule
  ],
  exports: [
    PreviousWarrantyDialogComponent
  ]
})
export class PreviousWarrantyDialogModule { }
